// extracted by mini-css-extract-plugin
export default {"resetButton":"xiEU5H5","documentBody":"izo8SP4"};